/**
 * @generated SignedSource<<133195ac1d54f9c5e2b5aa364a3b4035>>
 * @relayHash fb9fd5943d51bf5311dec5a35836db2d
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fb9fd5943d51bf5311dec5a35836db2d

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IssueClosedStateReason = "COMPLETED" | "NOT_PLANNED" | "%future added value";
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type UpdateIssuesBulkInput = {
  addToProjectV2Ids?: ReadonlyArray<string> | null;
  applyAssigneeIds?: ReadonlyArray<string> | null;
  applyLabelIds?: ReadonlyArray<string> | null;
  clearMilestone?: boolean | null;
  clientMutationId?: string | null;
  ids: ReadonlyArray<string>;
  issueTypeId?: string | null;
  milestoneId?: string | null;
  removeAssigneeIds?: ReadonlyArray<string> | null;
  removeLabelIds?: ReadonlyArray<string> | null;
  state?: IssueState | null;
  stateReason?: IssueClosedStateReason | null;
  unsetIssueType?: boolean | null;
};
export type updateIssueIssueTypeBulkMutation$variables = {
  input: UpdateIssuesBulkInput;
};
export type updateIssueIssueTypeBulkMutation$data = {
  readonly updateIssuesBulk: {
    readonly jobId: string | null;
  } | null;
};
export type updateIssueIssueTypeBulkMutation$rawResponse = {
  readonly updateIssuesBulk: {
    readonly jobId: string | null;
  } | null;
};
export type updateIssueIssueTypeBulkMutation = {
  rawResponse: updateIssueIssueTypeBulkMutation$rawResponse;
  response: updateIssueIssueTypeBulkMutation$data;
  variables: updateIssueIssueTypeBulkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIssuesBulkPayload",
    "kind": "LinkedField",
    "name": "updateIssuesBulk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueIssueTypeBulkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueIssueTypeBulkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "fb9fd5943d51bf5311dec5a35836db2d",
    "metadata": {},
    "name": "updateIssueIssueTypeBulkMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "80e52862748dd652ae22e4d09c73a917";

export default node;
